import React from "react";
import { Box, Grid, makeStyles, Paper, Typography } from "@material-ui/core";
import SummaryReport from "./SummaryReport";
import LineItemReport from "./LineItemReport";

export default function Reports({ report, loaded }) {
  const classes = useStyles();

  return (
    <Grid container spacing={2} justifyContent="space-between" className={classes.reportsContainer}>
      <Grid item xl={6} lg={6} md={12} sm={12} xs={12} className={classes.reportItem}>
        <Box className={classes.reportBox}>
          <Typography variant="subtitle1" className={classes.title}>
            Status Report
          </Typography>
          <Paper className={classes.summaryReportPaper}>
            <SummaryReport report={report} loaded={loaded} />
          </Paper>
        </Box>
      </Grid>
      <Grid item xl={6} lg={6} md={12} sm={12} xs={12} className={classes.reportItem}>
        <Box className={classes.reportBox}>
          <Typography variant="subtitle1" className={classes.title}>
            Line Report
          </Typography>
          <Paper className={classes.summaryReportPaper}>
            <LineItemReport report={report} loaded={loaded} />
          </Paper>
        </Box>
      </Grid>
    </Grid>
  );
}

const useStyles = makeStyles((theme) => ({
  reportsContainer: {
    flex: 1,
    minHeight: 0,
    height: "100%",
    alignContent: "stretch",
    alignItems: "stretch",
  },
  reportItem: {
    display: "flex",
    flexDirection: "column",
    flex: 1,
    minHeight: 300,
  },
  reportBox: {
    display: "flex",
    flexDirection: "column",
    flex: 1,
    minHeight: 0,
  },
  summaryReportPaper: {
    flex: 1,
    minHeight: 300,
    overflow: "hidden",
    display: "flex",
    flexDirection: "column",
  },
  title: {
    color: "rgb(135, 131, 131)",
  },
}));
